export default __webpack_public_path__ + "static/media/to-top.12ee9655.svg";